import { render, staticRenderFns } from "./GoPageConfirm.vue?vue&type=template&id=3cdc7686&scoped=true&"
import script from "./GoPageConfirm.vue?vue&type=script&lang=js&"
export * from "./GoPageConfirm.vue?vue&type=script&lang=js&"
import style0 from "./GoPageConfirm.vue?vue&type=style&index=0&id=3cdc7686&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc7686",
  null
  
)

export default component.exports